export const entryData = [
    {
        title: "classwork",
        subtitle: "view and submit schoolwork",
        links: [{label: "canvas", link: "https://bowdoin.instructure.com"},
                {label: "gradescope", link: "https://www.gradescope.com"}]
    },
    {
        title: "outlook",
        subtitle: "view and send email",
        links: [{label: "email", link: "https://outlook.office.com/mail/"},
                {label: "calendar", link: "https://outlook.office.com/calendar/"}]
    },
    {
        title: "dining services",
        subtitle: "view dining hall menus and hours",
        links: [{label: "menu", link: "https://bowdoin.edu/dining/menus/"},
                {label: "hours", link: "https://bowdoin.edu/dining/hours-and-locations/"}]
    },
    {
        title: "onecard",
        subtitle: "view your onecard data",
        links: [{label: "meal swipes", link: "https://csgoldweb.bowdoin.edu"},
                {label: "money stored", link: "https://csgoldweb.bowdoin.edu"}]
    },
    {
        title: "housing & mail",
        subtitle: "view your current residence/mailing address, or apply for housing",
        links: [{label: "current", link: "https://luminis.bowdoin.edu/"},
                {label: "apply", link: "https://starrez.bowdoin.edu"}]
    },
    {
        title: "community",
        subtitle: "view what others are up to",
        links: [{label: "events", link: "https://bowdoin.campusgroups.com/web_app?id=24706&menu_id=55996"},
                {label: "club list", link: "https://bowdoin.campusgroups.com/club_signup?view=all&"}]
    },
    {
        title: "courses",
        subtitle: "view your current and previous courses",
        links: [{label: "current", link: "https://luminis.bowdoin.edu"},
                {label: "previous", link: "https://degreeworks.bowdoin.edu"}]
    },
    {
        title: "registration",
        subtitle: "view and register for upcoming courses",
        links: [{label: "register", link: "https://polaris.bowdoin.edu/Registration"},
                {label: "class listing", link: "https://apphub.bowdoin.edu/classfinder/"}]
    },
    {
        title: "financial services",
        subtitle: "view payment and financial aid information",
        links: [{label: "bill", link: "https://apps.bowdoin.edu/quikpayweb/studentlogin"},
                {label: "financial aid", link: "https://netpartner.bowdoin.edu"}]
    },
    {
        title: "labor services",
        subtitle: "view labor opportunities or submit time",
        links: [{label: "apply", link: "https://studentemployment.bowdoin.edu/JobX_FindAJob.aspx"},
                {label: "submit time", link: "https://www.myworkday.com/bowdoin/"}]
    }, 
    {
        title: "health",
        subtitle: "view supports for your well-being",
        links: [{label: "physical", link: "https://bowdoin.edu/health/"},
                {label: "mental", link: "https://bowdoin.edu/counseling/"}]
    },
    {
        title: "location",
        subtitle: "view where you are",
        links: [{label: "campus map", link: "https://www.bowdoin.edu/about/campus-location/maps/campus-map.pdf"},
                {label: "local map", link: "https://www.google.com/maps/place/Brunswick,+ME+04011"}]
    },
    {
        title: "rules",
        subtitle: "view the rules",
        links: [{label: "handbook", link: "https://www.bowdoin.edu/dean-of-students/ccs/"}]
    },
    {
        title: "course evals",
        subtitle: "view or submit course evaluations",
        links: [{label: "BCQs", link: "https://blackboard.bowdoin.edu/webapps/portal/execute/tabs/tabAction?tab_tab_group_id=_218_1"}]
    },
    {
        title: "Bearable",
        subtitle: "help improve Bearable!",
        links: [{label: "suggestions", link: "https://github.com/FoxSylv/bearable/issues/new"},
                {label: "pull request", link: "https://github.com/FoxSylv/bearable/pulls"}]
    },
];
